export const FINANCING_ENDING_BULK_OPERATION_STATE = {
  PENDING: 'PENDING',
  IN_PROGRESS: 'IN_PROGRESS',
  DONE: 'DONE',
  PARTIALLY_DONE: 'PARTIALLY_DONE',
  FAILED: 'FAILED',
  RESOLVE_FAILED: 'RESOLVE_FAILED',
  CANCELLED: 'CANCELLED',
} as const;
